module.exports = __webpack_public_path__ + "2b0de036782329537623a0442532ce13.png";